import config from '../data/priority.json';

/**
 * Rótulo em português para um código de prioridade da API (ex.: HIGH).
 * Tolerância a case: normaliza para maiúsculas antes do lookup.
 */
export const getPriorityLabel = (code) => {
  if (code == null || code === '') return '';
  const key = String(code).toUpperCase();
  return config.label[key] ?? String(code);
};

/**
 * Opções { value, label } para filtros (ex.: FieldFilter), derivadas de `priority.json`.
 */
export const getPriorityFilterOptions = () =>
  Object.keys(config.label).map((key) => ({
    value: config.value[key] ?? key,
    label: config.label[key]
  }));

/** Lista estável na carga do módulo — use em `items` de filtros. */
export const PRIORITY_FILTER_OPTIONS = getPriorityFilterOptions();
